import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/inventory-turnover-calculator',
  component: () => import('../../routes/InventoryTurnoverCalculator.svelte'),
  card: {
    id: 'inventory-turnover',
    title: 'Inventory Turnover Calculator',
    description: 'Calculate how many times inventory is sold and replaced over a period. Measures inventory management efficiency.',
    icon: 'inventory_2',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/inventory-turnover-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Inventory Turnover Calculator – Free Inventory Efficiency Tool',
    description: 'Free inventory turnover calculator. Calculate how efficiently a company turns its inventory into sales using COGS and average inventory data.',
  },
};

export default meta;